import { atom } from 'recoil'
import { EditableJob } from '../../types/EditableJob'

export const JobsAtom = atom<EditableJob[] | undefined>({
  key: 'jobsForManagement',
  default: undefined,
})
